/** Amber highlight applied to external (non-domain-handle) participants and
 *  recipients. Shared by the participant- and email-recipient blocks so the two
 *  render external people identically. */
export const externalParticipantStyles = "bg-amber-100 border-amber-300";
